import { Home } from "lucide-react";

export function HomePage() {
  return (
    <div className="mx-auto max-w-7xl px-6 py-8">
      <div className="flex items-center gap-2 mb-6">
        <Home className="h-6 w-6" />
        <h1 className="text-xl font-semibold">Home</h1>
      </div>
      <p className="text-muted-foreground">Welcome to n8nvibes. Select a workspace to get started.</p>
    </div>
  );
}
